import React from "react";
import InspectionTypeScheduleCalendarWeekControls from "./InspectionTypeScheduleCalendarWeekControls";
import InspectionTypeScheduleCalendarRow from "./InspectionTypeScheduleCalendarRow";
import InspectionTypeScheduleCalendarHeader from "./InspectionTypeScheduleCalendarHeader";
import { InspectionRequestPreferenceMeridiem } from "../utils/InspectionRequestPreferenceMeridiem";
import useInspection from "../../../../hooks/inspections/useInspection";
import { CalendarDate } from "@internationalized/date";
import useInspectionSchedule from "../../../../hooks/inspections/useInspectionSchedule";

export interface IInspectionTypeScheduleCalendar {
  inspectionTypeId?: string;
  inspectionId?: string;
  currentWeek: CalendarDate;
  setCurrentWeek: (date: CalendarDate) => void;
  selectedInspectorId: string | null;
  selectedDate: CalendarDate | null;
  selectedMeridiem: InspectionRequestPreferenceMeridiem | null;
  setSelectedInspectorId: (inspectorId: string | null) => void;
  setSelectedDate: (date: CalendarDate | null) => void;
  setSelectedMeridiem: (meridiem: InspectionRequestPreferenceMeridiem | null) => void;
  onNextWeekClick: () => void;
  onPrevWeekClick: () => void;
  onSelect: (id: string, day: string, meridiem: "AM" | "PM") => void;
}
export default function InspectionTypeScheduleCalendar({
  inspectionTypeId,
  inspectionId,
  currentWeek,
  selectedInspectorId,
  selectedDate,
  selectedMeridiem,
  onNextWeekClick,
  onPrevWeekClick,
  onSelect,
}: IInspectionTypeScheduleCalendar) {
  const { inspectionQuery } = useInspection({ id: inspectionId ?? "", enabled: inspectionId !== undefined });

  const inspectionInspectionTypeId: string =
    (inspectionQuery.data?.data.attributes as any)?.["inspections-types-id"] ?? "";
  inspectionTypeId = inspectionTypeId ? inspectionTypeId : inspectionInspectionTypeId;
  const inspectorSchedule = useInspectionSchedule(inspectionId ?? "");
  const inspectors = inspectorSchedule.data?.inspectors ?? [];

  return (
    <div>
      <InspectionTypeScheduleCalendarWeekControls
        date={currentWeek}
        onLeftClick={onPrevWeekClick}
        onRightClick={onNextWeekClick}
      />
      <div className='tw-overflow-x-scroll tw-px-4'>
        <InspectionTypeScheduleCalendarHeader inspectionId={inspectionId} date={currentWeek} />
        <div className='tw-grid-cols-9'>
          {inspectors.map((inspector, index) => {
            return (
              <InspectionTypeScheduleCalendarRow
                key={index}
                inspectionTypeId={inspectionTypeId ?? ""}
                inspectionId={inspectionId}
                rowName={`${inspector.firstName} ${inspector.lastName}`}
                onSelect={onSelect}
                inspectorId={inspector.id.toString()}
                currentWeek={currentWeek}
                selectedDate={selectedDate}
                selectedInspectorId={selectedInspectorId}
                selectedMeridiem={selectedMeridiem}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
